import {Component, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {UserLoadActions, UserPageActions} from '../../store/user/actions/userActions';
import {selectUser, selectUserLoading, selectUserPage} from '../../store/user/selectors/user.selectors';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {ActivatedRoute, Router} from '@angular/router';
import {Route} from '../../enum/route';
import {UserService} from '../../services/user/user.service';
import {filter, take} from 'rxjs';
import {CompanyService} from '../../services/company-service/company.service';
import {switchMap} from 'rxjs/operators';
import {CustomDialogService} from '../../services/custom-dialog/custom-dialog.service';
import {environment} from 'src/environments/environment';
import {Roles} from '../../enum/roles';


@Component({
    selector: 'app-profile-user',
    templateUrl: './profile-user.component.html',
    styleUrls: ['../../../styles/profile.scss'],
    standalone: false
})
export class ProfileUserComponent implements OnInit {
  userPage$ = this.userStore.select(selectUserPage);
  activeUserId: string;
  pageUserId: string;
  companyRole: string;
  image: any;
  loading$ = this.userStore.select(selectUserLoading);
  showEditField: boolean = true;
  Route = Route;
  logo;

  profilePicture;
  titlePicture;
  showCompleteIntroductionText: boolean = false;
  maxLobShown = 3;
  editImage: boolean = true;
  environment = environment;

  constructor(private readonly activatedRoute: ActivatedRoute,
              readonly router: Router,
              public userStore: Store<UserAppState>,
              public userService: UserService,
              public companyService: CompanyService,
              private readonly customDialogService: CustomDialogService) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      if (params['id'] == null) {
        this.router.navigate(['/' + Route.INSERATE]);
      } else {
        this.pageUserId = params['id'];
        this.reloadInformation();
      }
    });
    this.userStore.select(selectUser).pipe(take(1)).subscribe(
      user => {
        this.activeUserId = user.id;
      }
    );
    this.activatedRoute.queryParamMap.subscribe(maps => {
      if (maps.get('previousRoute') == 'lobModal') {
        this.showEditField = true;
      }
    });
  }


  onFileChange(event, id) {
    let file = event.target.files[0];
    if (file.size > 2e+6) {
      this.customDialogService.imageUploadError();
      return;
    }
    if (id === 'profilePicture') {
      this.userService.setProfilePicture(this.pageUserId, file).subscribe(_ => this.reloadInformation());
    } else if (id === 'titlePicture') {
      this.userService.setTitlePicture(this.pageUserId, file).subscribe(_ => this.reloadInformation());
    }
  }

  deleteProfilePicture() {
    this.userService.deleteProfilePicture(this.pageUserId).subscribe(_ => this.reloadInformation());
  }

  reloadInformation() {
    this.userService.getProfilePicture(this.pageUserId)
      .subscribe(v => this.profilePicture = v);
    this.userService.getTitlePicture(this.pageUserId)
      .subscribe(v => this.titlePicture = v);
    this.userPage$.pipe(
      filter(userPager => userPager != null),
      take(1),
      switchMap(userPage => {
        const companyId = userPage.companyId;
        this.companyService.getCompanyRole(companyId)
          .subscribe(companyRole => {
            this.companyRole = companyRole.companyRole;
          });
        return this.companyService.getLogo(companyId);
      })
).subscribe(logo => this.logo = logo);
    let userId = this.pageUserId;
    this.userStore.dispatch(UserPageActions.load({userId}));
    userId = this.activeUserId;
    if (this.activeUserId) {
      this.userStore.dispatch(UserLoadActions.load({userId}));
    }
    this.showEditField = false;
    this.editImage = false;
  }

  toggleCompleteIntroductionText() {
    this.showCompleteIntroductionText = !this.showCompleteIntroductionText;
  }

  toggleMaxLobShow() {
    if (this.maxLobShown !== 3) {
      this.maxLobShown = 3;
    } else {
      this.maxLobShown = Number.MAX_SAFE_INTEGER;
    }
  }

  closeEditField() {
    this.showEditField = false;
  }

    protected readonly Roles = Roles;
}

